<div class="loader">
    <motif-progress-loader [show]="true" [fullScreen]="true"></motif-progress-loader>
    <p class="loader-message">{{'Authe-Wait-Message' |translate}}</p>
</div>